<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import InlineRadio from "../../components/inline-radio.svelte";
    import Spinner from "../components/spinner.svelte";
    import Select from "../components/select.svelte";
    import Router,{resolveExportUrl} from "../../router.js";
    import Card from "../components/card.svelte";
    import { multiselectAction } from "../../components/multiselect-action.js";
    import DataTable from "../../components/data-table.svelte";
    import Modal from "../components/modal.svelte"
    import HelpIcon from "../components/helpIcon.svelte";
    import Button from "../components/button.svelte";

    export let providerId = 0;
    export let config;
    export let errMsg = '';
    export let years = [];

    export const SaveYears = async () => {
        
        if (!config.syncPupils)
            config.ignoredYears = [];
        else
        {
            var selected = jQuery(selectElemYear).val();
            config.ignoredYears = selected && selected.length > 0 ? years.filter( year => !selected.includes(year.categoryId.toString())) : [];
        }
    }

    let addressFormats = [
        { id: 1, text: "Initial.Last (e.g. j.smith@wavenet.co.uk)", value:"Initial.Last" },
        { id: 2, text: "First (e.g. john@wavenet.co.uk)", value:"First" },
        { id: 3, text: "Last (e.g. smith@wavenet.co.uk)", value:"Last" },
        { id: 4, text: "Title.Last (e.g. mr.smith@wavenet.co.uk)", value:"Title.Last" },
        { id: 5, text: "First.Last (e.g. john.smith@wavenet.co.uk)", value:"First.Last" },
        { id: 6, text: "FirstLast (e.g. johnsmith@wavenet.co.uk)", value:"FirstLast" },
        { id: 7, text: "InitialLast (e.g. jsmith@wavenet.co.uk)", value:"InitialLast" },
        { id: 8, text: "InitialLast.LEA (e.g. jsmith.000@wavenet.co.uk)", value:"InitialLast.LEA" },
        { id: 9, text: "First.Initial (e.g. john.s@wavenet.co.uk)", value:"First.1Last" },
        { id: 10, text: "FirstInitial (e.g. johns@wavenet.co.uk)", value:"First1Last" },
        { id: 11, text: "LastInitial (e.g. smithj@wavenet.co.uk)", value:"LastInitial" },
        { id: 12, text: "USO (e.g. uso@wavenet.co.uk)", value:"UserId" },
        { id: 13, text: "USO.LEA (e.g. uso.000@wavenet.co.uk)", value:"Username" },
    ];

    let domains = [];
    let orgUnits = [];
    let isLoading = true;
    let selectElemYear;
    let usersWithShortPasswords = [];
    let showShortPasswords = false;
    let datatable;
    let staffAliasDomain = '';
    let staffAliasFormat = '';
    let pupilAliasDomain = '';
    let pupilAliasFormat = '';
    let configuredApps = [];
    let usoEmailAddressFormatOptions =[
                    { label: "Do not populate", value: 'none' }                    
                ];

    onMount(async () => {

        await GetDomains();

        if (providerId == 1)
           await GetOrgUnits();

        // we hash password for google
        if (providerId ==  3)
            await GetUsersWithShortPasswords();
        await GetConfiguredApps();
      

        setTimeout(() => {
            if (config.ignoredYears)
            {
                years.forEach((item, i ) => {
                    if ( !config.ignoredYears.some( ignore => ignore.categoryId == item.categoryId ))
                    {
                        jQuery(selectElemYear).multiselect('select', item.categoryId, true);  
                    }
                })
            }
        }, 0 );

        isLoading = false;
    });

    const GetDomains = async () => {

        let resp = await wrappedFetch(
                    `/api/cloud/GetDomains?providerId=` + providerId,
                    { method: "post" }
                );
        domains = await resp.json();

        if (domains.length == 0)
        {
            Router.route(resolveExportUrl(providerId,'/step1'), false);
        }
    }

    const GetOrgUnits = async () => {
        let resp = await wrappedFetch(
            `/api/cloud/GetOrgUnits?providerId=` + providerId,
            { method: "post" }
        );
        orgUnits = await resp.json();
    }


    const GetUsersWithShortPasswords = async () => {
        let resp = await wrappedFetch(`/api/reports/GetUsersWithShortPasswords`, {
            method: "post",
        });
        usersWithShortPasswords  = await resp.json();
    }

    const GetConfiguredApps = async () => {

let resp = await wrappedFetch(
            `/api/cloudConfig/GetConfiguredApps`,
            { method: "post" }
        );
configuredApps = await resp.json();

console.log('configuredApps',configuredApps)
if(providerId == 1 || configuredApps.includes(1))
        usoEmailAddressFormatOptions.push({   label: "GoogleSync email format", value: 'google' })
        if(providerId == 3 || configuredApps.includes(3))
        usoEmailAddressFormatOptions.push({   label: "MicrosoftSync email format", value: 'microsoft' })
}

    $: { 
        if (!config.syncPupils)
            jQuery(selectElemYear).multiselect('disable');  
        else
            jQuery(selectElemYear).multiselect('enable');  
    }
 
    const addStaffAlias = () => {
    if (config.staffAliases == null)
            config.staffAliases = [];

        config.staffAliases = [...config.staffAliases, {format: staffAliasFormat, domain: staffAliasDomain}];
        staffAliasDomain ='';
        staffAliasFormat='';
    }

    const deleteStaffAlias = (index) => {
        config.staffAliases.splice(index, 1);
        config.staffAliases = config.staffAliases;
    }

    const addPupilAlias = () => {
        if (config.pupilAliases == null)
            config.pupilAliases = [];

        config.pupilAliases = [...config.pupilAliases, {format: pupilAliasFormat, domain: pupilAliasDomain}];
        pupilAliasDomain ='';
        pupilAliasFormat='';
    }

    const deletePupilAlias = (index) => {
        config.pupilAliases.splice(index, 1);
        config.pupilAliases = config.pupilAliases;
    }

</script>
<style>
    /* WIP */
    .dropdown-toggle.btn.btn-default::after {
        float: right !important;
        margin-top: 5px !important;
        /* width: .5em !important;
        height: .5em !important;
        /* margin: -.3em 0 0 .4em; */
        /* vertical-align: middle; */
        /*content: "";
        border: 0.25em solid !important;
        border-width: 0 .15em .15em 0 !important;
        transform: rotateZ(45deg) !important; */
        color: #495057 !important
    }

</style>

{#if config && domains.length > 0 && !isLoading }
<Card>
    <div slot="header">   <h3>Pupils</h3></div><div slot="body">
        <div class="form-group">
            <label for="syncPupil" style="display:block;">Create pupils?</label>
            <InlineRadio id="syncPupil"
                name="student-accounts"
                bind:value={config.syncPupils}
                options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]}
            />
        </div>        
        <div class="form-group">
            {#if years && years.length > 0}
            <label for="yearsSelect" class="{!config.syncPupils ? 'labeldisabled' : ''}">Which year groups do you want to create? </label>
                <select id="yearsSelect"
                    multiple="multiple"
                    bind:this={selectElemYear}
                    use:multiselectAction={{
                        buttonWidth: '100%', 
                        maxHeight: 500, 
                        numberDisplayed : 4, 
                        includeSelectAllOption: true,
                        enableFiltering: true,
                        includeFilterClearBtn: true,
                        enableCaseInsensitiveFiltering: true,
                        templates: {
                            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" style="text-align: left; border: 1px solid lightgrey; color: #495057;">\
                                        <span class="multiselect-selected-text"></span>\
                                    </button>'
                        } 
                    }}>

                    {#each years as item}
                        <option value={item["categoryId"]}>
                            {item["year"]}
                        </option>
                    {/each}

                </select>
            {/if}
        </div>
        <div class="form-group">
            <label for="pupilDomain" class="{!config.syncPupils ? 'labeldisabled' : ''}">Which domain do you want to use for pupils?</label>
            <Select id="pupilDomain"
                bind:selected={config.pupilDomain} 
                items={domains} 
                value={'domainName'} 
                label='domainName' 
                placeholderText='pupil domain' 
                disabled={!config.syncPupils}/>
        </div>
        <div class="form-group">
            <label for="emailSelect" class="{!config.syncPupils ? 'labeldisabled' : ''}">Which naming convention do you want to use for pupils?
            <HelpIcon message="If accounts are already present in your tenancy then choosing a different format for primary emails will add new format as an alias rather than primary email. If you wish to change primary account format then please raise a support case with us before you complete setting up the sync." />
        </label>
            <Select id="emailSelect"
                bind:selected={config.pupilEmailFormat} 
                items={addressFormats} 
                value={'value'} 
                label='text' 
                placeholderText='pupil email format'
                disabled={!config.syncPupils}  />
        </div>

        <div class="form-group">
            <label for="emailAliasSelect" class="{!config.syncPupils ? 'labeldisabled' : ''}">Do you wish to add aliases for pupil? (optional)</label>
            <br />
            {#if config.pupilAliases != null}
                {#each config.pupilAliases as alias, index}
                <Select id="emailAliasSelect"
                    bind:selected={alias.format} 
                    items={addressFormats} 
                    value={'value'} 
                    label='text' 
                    placeholderText='pupil alias format'
                    width=47.9
                    style="margin-bottom: 3px;"
                    disabled={!config.syncPupils}  />

                <Select id="pupilAliases"
                    bind:selected={alias.domain} 
                    items={domains} 
                    value={'domainName'} 
                    label='domainName' 
                    placeholderText='pupil alias domain'
                    width=47.9
                    disabled={!config.syncPupils}/>

                <!-- fa-trash-o -->
                <Button
                    buttonClass={"btn-grey"}
                    style="min-width:35px; vertical-align: top;"
                    buttonText={"<i class='fa fa-times'></i>"}
                    on:click={() => deletePupilAlias(index)}
                />
                <br/>
                {/each}
            {/if}
            <hr style="margin-top: 10px !important; margin-bottom: 2px !important;" />
            <Button
                buttonClass={"btn-grey"}
                disabled={!config.syncPupils ? true : false}
                style="min-width:100%; vertical-align: top; text-align: left; border-color: transparent !important; background-color: transparent;"
                buttonText={"<i class='fa fa-plus' style='color: #2e817d;'></i> Add Alias"}
                on:click={addPupilAlias}
            />
            <hr style="margin-top: 2px !important; margin-bottom: 10px !important;" />
        </div>
    </div>
</Card>
<br />
<Card>
    <div slot="header"><h3>Staff</h3></div><div slot="body">
        <div class="form-group">
            <label for="syncStaff" style="display:block;">Create staff?</label>
            <InlineRadio id="syncStaff"
                name="staff-accounts"
                bind:value={config.syncStaff}
                options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]} />
        </div>
        <div class="form-group">
            <label for="staffDom" class="{!config.syncStaff ? 'labeldisabled' : ''}">Which domain do you want to use for staff?</label>
            <Select id="staffDom"
                bind:selected={config.staffDomain} 
                items={domains} 
                value={'domainName'} 
                label='domainName' 
                placeholderText='staff domain'
                disabled={!config.syncStaff} />
        </div>
        <div class="form-group">
            <label for="staffEmail" class="{!config.syncStaff ? 'labeldisabled' : ''}">Which naming convention do you want to use for staff?
                <HelpIcon message="If accounts are already present in your tenancy then choosing a different format for primary emails will add new format as an alias rather than primary email. If you wish to change primary account format then please raise a support case with us before you complete setting up the sync." />
            </label>
            <Select id="staffEmail"
                bind:selected={config.staffEmailFormat} 
                items={addressFormats} 
                value={'value'} 
                label='text' 
                placeholderText='staff email format'
                disabled={!config.syncStaff} />
        </div>
        <!-- {#if providerId == 1} -->
        <div class="form-group">
            <label for="titleFirst" style="display:block;">
                Replace first name with title for staff?
                <HelpIcon message="First name for staff will be replaced by title (if present) or inital e.g. Mr J Smith or J Smith" />
            </label>
            <InlineRadio id="titleFirst"
                name="title-first"
                bind:value={config.titleFirst}
                options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]} />
        </div>
        <!-- {/if} -->
        
        <div class="form-group">
            <label for="emailAliasSelect" class="{!config.syncStaff ? 'labeldisabled' : ''}">Do you wish to add aliases for staff? (optional)</label>
            <br />
            {#if config.staffAliases != null}
                {#each config.staffAliases as alias, index}
                <Select id="emailAliasSelect"
                    bind:selected={alias.format} 
                    items={addressFormats} 
                    value={'value'} 
                    label='text' 
                    placeholderText='staff alias format'
                    width=47.9
                    style="margin-bottom: 3px;"
                    disabled={!config.syncStaff}  />

                <Select id="staffAliases"
                    bind:selected={alias.domain} 
                    items={domains} 
                    value={'domainName'} 
                    label='domainName' 
                    placeholderText='staff alias domain'
                    width=47.9
                    disabled={!config.syncStaff}/>

                <!-- fa-trash-o -->
                <Button
                    buttonClass={"btn-grey"}
                    style="min-width:35px; vertical-align: top;"
                    buttonText={"<i class='fa fa-times'></i>"}
                    on:click={() => deleteStaffAlias(index)}
                />
                <br/>
                {/each}
            {/if}

            <hr style="margin-top: 10px !important; margin-bottom: 2px !important;" />
            <Button
                buttonClass={"btn-grey"}
                disabled={!config.syncStaff ? true : false}
                style="min-width:100%; vertical-align: top; text-align: left; border-color: transparent !important; background-color: transparent;"
                buttonText={"<i class='fa fa-plus' style='color: #2e817d;'></i> Add Alias"}
                on:click={addStaffAlias}
            />
            <hr style="margin-top: 2px !important; margin-bottom: 10px !important;" />
            
        </div>
    </div>
</Card>
<br>
<Card>
    <div slot="header">  
        <h3>General</h3>
    </div>
    <div slot="body">
        <div class="form-group">
            <label for="password" style="display:block;">
                Keep USO passwords in sync? <HelpIcon message="Users imported from your MIS are automatically generated a USO account. 
                This USO account is unique to the user and is their identity on Wavenet systems. 
                When the sync creates a new account, their initial password will be the same as their USO account’s. 
                You can choose to keep the password in sync so their USO password is always the one used, 
                or choose not to keep password in sync so passwords will be managed in 
                {providerId > 0 && providerId == 1 ? 'Google' : 'Microsoft'}. 
                More info is available in the guide." />
            </label>
            
            <InlineRadio for="password"
                name="user-passwords"
                bind:value={config.syncUSOPassword}
                options={[
                    { label: "Yes", value: true},
                    { label: "No", value: false },
                ]}
            />
            {#if config.syncUSOPassword }  
            <div class="alert alert-info mt-2" role="alert">
                <span>Please note that if you choose "yes", any changes made to the password on the tenancy will be replaced during the subsequent sync process.</span>
                {#if usersWithShortPasswords.length > 0}
                <br/><br/>
                <span>There are <b><a href="javascript:;" on:click={()=> showShortPasswords = true} style="text-decoration: underline;">{usersWithShortPasswords.length} users</a></b> that do not meet Microsoft's minimum password length requirement of 8 characters. In order to sync these users we will modify their passwords in 365 to add the “#” character on the end of their passwords to meet the limit. We would strongly recommend changing these user’s passwords on the Users page to meet the requirement.</span>
                {/if}                
            </div>
          
            {/if}
        </div>
        {#if !config.syncUSOPassword}
        <div class="form-group">
            <label for="forcechange" style="display:block;">
                Force new users to change password on first login? 
            </label>
            
            <InlineRadio for="forcechange"
                name="force-passwords"
                bind:value={config.forceChangePassword}
                options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]}
            />
        </div>
        {/if}
        <div class="form-group">
            <label for="useLegal" style="display:block;">Use legal or preferred names for account and email creation? </label>
            <InlineRadio id="useLegal"
                name="useLegal"
                bind:value={config.useLegal}
                options={[
                    { label: "Legal", value: true },
                    { label: "Preferred", value: false },
                ]}
            />
        </div>

        {#if providerId == 1}
        <div class="form-group">
            <label for="orgUnit">Which root organisational unit do you want to use to create and manage users?</label>
            <div class="input-group">
            <Select id="orgUnit"
                bind:selected={config.rootOrgUnit}
                width={90} 
                items={orgUnits} 
                value={'name'} 
                label='name' 
                placeholderText='root organisational unit' />
            <div class="input-group-addon input-group-button">
                <button class="btn btn-md btn-grey" on:click={GetOrgUnits}><span class="material-icons">autorenew</span></button>
            </div>
        </div>
        </div>
        {/if}

        <div class="form-group">
            <label for="autoDeleteAccount" style="display:block;">Auto delete users?
                <HelpIcon message="Users will not be deleted from the tenancy; instead, Nimbus will merely suspend them. By opting in to auto-delete, any suspended users will be deleted automatically after the number of days you choose below." /> </label>
            <InlineRadio id="autoDeleteAccount"
                name="autoDeleteAccount"
                bind:value={config.autoDeleteAccount}
                options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]}
            />
        </div>

        {#if config.autoDeleteAccount}
        <div class="form-group">
            <label for="deletionDelayInDays" style="display:block;">Auto delete after how many days? </label>
            <InlineRadio id="deletionDelayInDays"
                name="deletionDelayInDays"
                bind:value={config.deletionDelayInDays}
                options={[
                    { label: "20 days", value: 20 },
                    { label: "30 days", value: 30 },
                    { label: "90 days", value: 90 },
                ]}
            />
        </div>
        {/if}
        <div class="form-group">
            <label for="usoEmailAddressFormat" style="display:block;">Populate user accounts that have no email addresses?
            <HelpIcon message=" This configuration affects both GoogleSync and MicrosoftSync."/> </label>                
            <InlineRadio id="usoEmailAddressFormat"
                name="usoEmailAddressFormat"
                bind:value={config.usoEmailAddressFormat}
                options={usoEmailAddressFormatOptions}
            />
        </div>

        
        <!-- {#if providerId == 3}
        <div class="form-group">
            <label for="abp" style="display:block;">Use address book policies?
                <HelpIcon message="Jing needs to write this text :)" />
            </label>
            <InlineRadio id="abp"
                name="abp"
                bind:value={config.supportABPs}
                options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]} 
            />
        </div>
        {/if} -->

    </div>
</Card>
{:else}
    <Spinner />
{/if}

{#if showShortPasswords}
<Modal bind:showModal={showShortPasswords} on:show={()=>datatable.adjust()} >
    <div slot="header"><h4>Users with short passwords</h4></div>
    <div slot="content">
        <DataTable DataLength={usersWithShortPasswords.length} bind:this={datatable} isFixedHeight={true} message="Passwords for all users meet minimum criterion.">
            <thead>
                <tr>                    
                    <th>User</th>  
                    <th>USO ID</th>
                </tr>
            </thead>
            <tbody>
                {#each usersWithShortPasswords as user}
                <tr>
                    <td>{user.firstName} {user.lastName} </td>                
                    <td>{user.universalId}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
</Modal>
{/if}

{#if errMsg != ''}
    <div style="margin-top: 5px;">
        <span style="color:red;">{errMsg}</span>
    </div>
{/if}
